import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import BottomNav from './BottomNav'
import OnboardingTour from '../Onboarding/OnboardingTour'
import FloatingChat from '../FloatingChat/FloatingChat'

const Layout = () => {
  const [sidebarWidth, setSidebarWidth] = useState(() =>
    parseInt(localStorage.getItem('sidebarWidth') || '256', 10)
  )

  return (
    <div className="min-h-screen bg-gray-950 flex">
      <div className="hidden lg:flex">
        <Sidebar width={sidebarWidth} onWidthChange={setSidebarWidth} />
      </div>

      <main
        className="flex-1 min-h-screen overflow-x-hidden lg:[margin-left:var(--sidebar-w)]"
        style={{ '--sidebar-w': `${sidebarWidth}px` }}
      >
        <div className="p-3 sm:p-5 lg:p-8 pb-24 lg:pb-8">
          <Outlet />
        </div>
      </main>

      <div className="lg:hidden">
        <BottomNav />
      </div>

      <OnboardingTour />
      <FloatingChat />
    </div>
  )
}

export default Layout